import { RetailerEntity } from 'src/modules/retailer';

export enum BrandSpacesListingActions {
  FetchListingBegin = 'BRAND_SPACES/LISTING/FETCH/BEGIN',
  FetchListingSuccess = 'BRAND_SPACES/LISTING/FETCH/SUCCESS',
  FetchListingError = 'BRAND_SPACES/LISTING/FETCH/ERROR',
}

export interface BrandSpacesListingStore {
  isLoading: boolean;
  isLoaded: boolean;
  error: any;
  link: string;
  brandSpaces: RetailerEntity[];
}
